
$(document).ready(function () {
	
	function addStickyClass() {
		var footerEl = document.getElementById("footer");
		var socialEl = document.getElementsByClassName("event-share")[0];
		if (!footerEl || !socialEl || $("#event-sidebar").length === 0) return;

		var sidebarOffset = 120;
		var footerOffset = footerEl.offsetTop;
		var socialOffset = socialEl.offsetTop;
		var sidebarHeight = $("#event-sidebar").height();


		// fixed sidebar when past it
		if ($(document).scrollTop() > sidebarOffset) {
			$('#event-sidebar').addClass('sidebar-sticky');
		}
		else {
			$('#event-sidebar').removeClass('sidebar-sticky');
		}

		// don't let sidebar go past footer
		if ($(document).scrollTop() + sidebarHeight > footerOffset - 180) {
			$('#event-sidebar').addClass('footer-sticky');
		}
		else {
			$('#event-sidebar').removeClass('footer-sticky');
		}

		// on mobile, sticky to bottom always
		if ($(document).scrollTop() > socialOffset) {
			$('#event-sidebar').addClass('mobile-sticky');
		}
		else {
			$('#event-sidebar').removeClass('mobile-sticky');
		}
	}

	addStickyClass();

	// sticky sidebar 
	$(document).on('scroll', function () {
		addStickyClass();
	});
}); 